<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body>
    <section class="panel widget-container property-picture-container" (mouseenter)="mouseEnterEvent()" (mouseleave)="mouseLeaveEvent()">

      <mojo-property-gallery [galleryItems]="galleryItems | async"  [showThumbnails]="showThumbnails" [(activeIndex)]="activeIndex"  (dragover)="dragoverEvent($event)"  *ngIf="!(displayFileUploadWidget | async)"></mojo-property-gallery>

      <div *ngIf="userCanUpload();else userCannotUpload" class="full-height">
        <file-upload *ngIf="displayFileUploadWidget | async" (dragleave)="dragleaveEvent($event)" (uploadHandler)="fileUploadEvent($event)"
                     (onSelect)="onSelectEvent($event)" (onFileSizeLimitExceeded)="fileSizeLimitedExceeded($event)"
                     (onFileTypeNotSupported)="fileTypeNotSupported($event)" [supportedFileTypes]="supportedFileTypes">
        </file-upload>
      </div>

      <ng-template #userCannotUpload>
        <div *ngIf="(galleryItems | async)?.length === 0" class="ui-noimages-wrapper">
          <div class="ui-noimages-content">
            <i class="fa fa-home fa-4x"></i>
            <div class="ui-noimages-header">
              <label>No Property Picture <br> to display</label>
            </div>
          </div>
        </div>
      </ng-template>

      <div *ngIf="(userCanDelete() | async) && (galleryItems | async)?.length > 0" class="trash-container" pTooltip="Delete" tooltipPosition="bottom"
           (click)="deleteImage(activeIndex)">
        <i class="fa fa-trash-o trash" aria-hidden="true"></i>
      </div>

    </section>
  </ng-container>
</mojo-widget>
